import './style.css';

export default function Rodape() {
    return (
        <footer>
            <p>&copy; Pastelaria - Kina - Todos os direitos reservados</p>
            <p>Desenvolvido por <span>Diogo Kimisima</span></p>
        </footer>
    )
}